import { Route, Switch } from 'wouter';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './pages/Home';
import ShopsPage from './pages/Shops';
import ShopDetailPage from './pages/ShopDetail';
import TermsPage from './pages/Terms';
import PrivacyPage from './pages/Privacy';

function NotFound() {
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center p-8">
      <h1 className="text-6xl font-bold text-gray-300">404</h1>
      <p className="mt-4 text-xl text-gray-600">الصفحة غير موجودة</p>
      <a
        href="/"
        className="mt-8 inline-block rounded-xl bg-primary-600 px-6 py-3 font-semibold text-white transition hover:bg-primary-700"
      >
        العودة للرئيسية
      </a>
    </div>
  );
}

export default function App() {
  return (
    <div className="min-h-screen flex flex-col" dir="rtl">
      <Header />
      <main className="flex-1">
        <Switch>
          <Route path="/" component={HomePage} />
          <Route path="/shops" component={ShopsPage} />
          <Route path="/shops/:slug" component={ShopDetailPage} />
          <Route path="/terms" component={TermsPage} />
          <Route path="/privacy" component={PrivacyPage} />
          <Route component={NotFound} />
        </Switch>
      </main>
      <Footer />
    </div>
  );
}
